import type { FormFieldState } from '@federa/types/ui-form-field';

/**
 * The id of a field's message element -- BOTH the `id` the message renders with and the value the control's
 * `aria-describedby` points at.
 *
 * ONE function for both sides, because they were two independent expressions in `Textarea` and that is the shape which
 * silently produces a dangling `aria-describedby` the moment one of them is edited. It keys on the resolved
 * `FormFieldState` rather than on an `(error, helperText)` pair: the pair predated the shared field-validity contract
 * (`FieldValidityProps`, `types/ui-form-field.ts`) and could not express the `success` state at all, so a valid-and-
 * confirmed field would have been described by an id nothing rendered.
 *
 * Whether to ATTACH the attribute is the caller's decision -- `aria-describedby` must be omitted, not pointed at an
 * absent element, when a field carries no message.
 */
export function buildFieldMessageId(elementId: string, state: FormFieldState): string {
	return state === 'error' ? `${elementId}-error` : `${elementId}-helper`;
}
